import { render, staticRenderFns } from "./ActionItemCard.vue?vue&type=template&id=014081b9&scoped=true&"
import script from "./ActionItemCard.vue?vue&type=script&lang=js&"
export * from "./ActionItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014081b9",
  null
  
)

export default component.exports